var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_72",
    "data-name": "Group 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.769,
    height: 18.215,
    viewBox: "0 0 22.769 18.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 22.769,
    height: 18.215
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M22.722,2.186a9.712,9.712,0,0,1-2.684.736A4.632,4.632,0,0,0,22.087.347a9.309,9.309,0,0,1-2.954,1.128,4.658,4.658,0,0,0-8.058,3.185,4.8,4.8,0,0,0,.108,1.062A13.185,13.185,0,0,1,1.582.849,4.659,4.659,0,0,0,3.014,7.075,4.6,4.6,0,0,1,.909,6.5v.051A4.68,4.68,0,0,0,4.641,11.13a4.649,4.649,0,0,1-1.221.153,4.119,4.119,0,0,1-.882-.08A4.7,4.7,0,0,0,6.89,14.448a9.36,9.36,0,0,1-5.776,1.987A8.725,8.725,0,0,1,0,16.371a13.114,13.114,0,0,0,7.146,2.09A13.167,13.167,0,0,0,20.4,5.206c0-.206-.007-.4-.017-.6a9.293,9.293,0,0,0,2.335-2.418"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.8b457cc79acf8b16446312e0fe5a4b8c.svg";
export { ForwardRef as ReactComponent };